import type { ProductStockListings } from 'types/capi/pdp';

import Tracked from '~/components/Tracked';
import WtbToggleViewEvent from '~/events/WtbToggleViewEvent';
import useRootData from '~/hooks/useRootData';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import { SelectedView } from './index';

type Props = {
  selectedView: SelectedView;
  setSelectedView: (view: SelectedView) => void;
  stockListings: ProductStockListings;
};

export default function ViewToggle({
  selectedView,
  setSelectedView,
  stockListings
}: Props) {
  const { RAFFLES, RETAILERS, MINIMISED } = SelectedView;

  const numOfRaffles = stockListings.raffles.length;
  const numOfRetailers = stockListings.affiliates.length;

  if (numOfRetailers === 0 && numOfRaffles === 0) return null;

  return (
    <div className="flex justify-center w-full gap-2">
      {numOfRetailers > 0 && (
        <Toggle
          isSelected={selectedView === RETAILERS}
          onClick={() =>
            setSelectedView(selectedView === RETAILERS ? MINIMISED : RETAILERS)
          }
          name="SHOW_ALL_RETAILERS"
        >
          Show {numOfRetailers} retailers
        </Toggle>
      )}
      {numOfRaffles > 0 && (
        <Toggle
          isSelected={selectedView === RAFFLES}
          onClick={() =>
            setSelectedView(selectedView === RAFFLES ? MINIMISED : RAFFLES)
          }
          name="SHOW_ALL_RAFFLES"
        >
          Show all raffles
        </Toggle>
      )}
    </div>
  );
}

function Toggle({
  onClick,
  children,
  isSelected,
  name
}: {
  children: React.ReactNode;
  isSelected: boolean;
  name: TrackedButtonClickName;
  onClick: () => void;
}) {
  const { isBot } = useRootData();

  return (
    <Tracked.Button
      onClick={() => {
        onClick();

        return new WtbToggleViewEvent({
          isBot,
          trackedButtonName: name
        }).send();
      }}
      className="!rounded-full text-nowrap max-w-40"
      pagePosition="WTB"
      name={name}
      variant={isSelected ? 'black' : 'white-grey-border'}
    >
      <p className="flex items-center justify-center gap-1 font-light text-sm p-0.5">
        {children}
      </p>
    </Tracked.Button>
  );
}
